import { P as Pagination } from './swiper-pagination.js';
import { S as Swiper } from './swiper-index.js';
import './swiper-classes-to-selector.js';
import './swiper-create-element.js';
import './swiper-core.js';
import './swiper-a11y.js';

class FeaturedBlog extends HTMLElement {
  connectedCallback() {
    this.swiper = Swiper(this, {
      modules: [Pagination],
      spaceBetween: 16,
      slidesPerView: 1.15,
      breakpoints: {
        640: {
          slidesPerView: 2.3,
        },
        1024: {
          slidesPerView: 3.5,
          spaceBetween: 24,
        },
        1280: {
          slidesPerView: 4.05,
        },
      },
      pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
        clickable: true,
        bulletElement: 'button',
      },
    });
  }
}

customElements.define('featured-blog-swiper', FeaturedBlog);
